import type { CustomResponseFormat } from "api/instance";

// 매칭 항목만 isDone(+ done 이면 lastDoneAt) 갱신. 나머지 항목과 응답 형태는 그대로.
// 백엔드 read-after-write 지연 동안 done/undone 상태를 홈 리스트 캐시에 선반영하기 위함.
// api/instance 는 type-only import 라 런타임 axios 로드 없음(jest ESM 회피).
export const applyDoneToList = <
  T extends { isDone: boolean; lastDoneAt?: string },
>(
  old: CustomResponseFormat<T[]> | undefined,
  match: (item: T) => boolean,
  nowIso: string,
  isDone: boolean = true
): CustomResponseFormat<T[]> | undefined => {
  if (!old?.result) return old;
  return {
    ...old,
    result: old.result.map((item) =>
      !match(item)
        ? item
        : isDone
          ? { ...item, isDone: true, lastDoneAt: nowIso }
          : { ...item, isDone: false }
    ),
  };
};
